export default __webpack_public_path__ + "static/media/bin_au.1aea2672.svg";